<template>
    <div class="col-12 align-self-center">
    <div class="card">
            <div class="card-body p-sm-3 p-md-5 h-100 d-flex flex-column">
                <div class="text-center">
                    <h4>{{ $t('welcome_title') }} {{ $state.login_info.kandidaatgeslacht === 'm' ? $t('welcome_sir') : $t('welcome_madam')}} {{ $state.login_info.kandidaatnaam }}!</h4>
                    <p class="text-muted">{{$t('welcome_permission')}}</p>
                    <button class="btn btn-success btn-lg mt-1" @click="nextPage">
                        <i class="fa fa-arrow-circle-right"></i> {{$t('next')}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            nextPage() {
               this.$router.push({name: 'test'});
            }
        }
    }
</script>
